import { startTransition, useCallback, useEffect, useRef, useState } from 'react';
import { getAccountProfile, getFallbackAccountProfile } from '../js/accountService';

export default function useAccountProfile(role) {
  const [profile, setProfile] = useState(() => getFallbackAccountProfile());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const requestIdRef = useRef(0);

  const loadProfile = useCallback(async () => {
    const requestId = requestIdRef.current + 1;
    requestIdRef.current = requestId;

    setLoading(true);
    setError(null);

    try {
      const nextProfile = await getAccountProfile();
      if (requestIdRef.current !== requestId) {
        return;
      }

      startTransition(() => {
        setProfile(nextProfile);
      });
    } catch (loadError) {
      if (requestIdRef.current !== requestId) {
        return;
      }

      startTransition(() => {
        setProfile(getFallbackAccountProfile());
      });
      setError(loadError?.message || 'No se pudo cargar el perfil.');
    } finally {
      if (requestIdRef.current === requestId) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    loadProfile();

    return () => {
      requestIdRef.current += 1;
    };
  }, [loadProfile, role]);

  return {
    profile,
    loading,
    error,
    reload: loadProfile,
  };
}